import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const feedbackService = {
    createForClient: async (data) => {
        try {
            const res = await axiosService.post(endPoints.feedback.toClient, data, {
                headers: {
                    "Content-Type": 'multipart/form-data'
                }
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
    createForCleaner: async (data) => {
        try {
            const res = await axiosService.post(endPoints.feedback.toCleaner, data, {
                headers: {
                    "Content-Type": 'multipart/form-data'
                }
            });

            return res;
        } catch (error) {
            throw error;
        }
    },
}

export {
    feedbackService,
}